<template>
<div class="row primary-filter">
  <div class="col-3 filter-grid">
    <ul>
      <li class="app-side-menu">
        <span @click="openMenu" class="pointer">
            <svgicon name="menu" width="20" height="20" :original="true" class="menu"/>
          </span>
        <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
          <Sidebar @close="onCloseMenu"/>
        </div>
      </li>
      <li class="category">
        <FilterDropdown :options="options"
        :selected="seletedOption"
        @updateOption="onChangeOption"/>
      </li>
    </ul>
  </div>
  <div class="filter-grid" :class="showPayment ? 'col marginleft-n' : 'col-3 search-leftalign'">
    <div class="app-search-label">
      <svgicon name="search" width="18" height="18" :original="true" />
      <span v-if="showPayment">
        <input placeholder="Indent ID or LR Number" @keyup="searchPayment"
          v-model="queryPayment">
      </span>
      <span v-else>
        <input placeholder="Invoice ID, Indent ID or LR number" @keyup="searchInvoice"
          v-model="queryInvoice">
      </span>
    </div>
  </div>

  <div class="filter-grid filter-button paysection" :class="showPayment ? 'col-8 noleftmargin' : 'col-6 v1-invoice'">
    <ul class="filter-btn-group">
      <li v-if="!showPayment" class="tempsublevel borderstyletemp">
        <FilterDropdown
        :options="invoiceFilters"
        :selected="selectedInvoiceType"
        @updateOption="onChangeInvoiceFilter" />
      </li>
      <li v-if="showPayment" class="tempsublevel dropdown-section">
        <div class="depotfilter">
      <Select v-model="selectedDepot" filterable searchable placeholder="Select Depot"
        value-key="id"
        popper-class="dropdownlisttag"
        @change="onChangeDepotFilter">
        <Option
          v-for="item in depotList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
         <span class="dropdownlisttag-text">{{ item.name }}</span>
        </Option>
      </Select>
    </div>
      </li>
      <li v-if="showPayment" class="tempsublevel">
        <FilterDropdown :options="indentFilters"
        :selected="seletedIndentType"
        @updateOption="onChangeIndentFilter" />
      </li>
       <li v-if="showPayment" class="tempsublevel">
        <FilterDropdown :options="vehicleTypes"
        :selected="seletedVehicleType"
        @updateOption="onChangeVehicleType" />
      </li>
      <li class="datepickerrange calenderstyle" v-if="showPayment">
        <div class="datepicker-trigger">
              <input
                type="text"
                id="datepicker-trigger"
                placeholder="Start Date - End Date"
                :value="formatDates(startDate, endDate)">
              <AirbnbStyleDatepicker
                :trigger-element-id="'datepicker-trigger'"
                :mode="'range'"
                :date-one="startDate"
                :date-two="endDate"
                @apply="filterByDate"
                @date-one-selected="val => { startDate = val }"
                @date-two-selected="val => { endDate = val }"/>
            </div>
            <div @click="clearDate" class="datepickerrange-cancel">
              <svgicon name="cancelblack" width="8" height="8" :original="true" class="menu" />
            </div>
      </li>
      <li v-if="showCreateInvoice && showPayment">
        <router-link :to="{ name: 'OrderDetail'}" v-if="canCreateInvoice">
          <button class="btn btn-primary">Create Invoice</button>
        </router-link>
        <button class="btn btn-primary" disabled v-else>Create Invoice</button>
      </li>
      <li v-if="!showPayment" class="">
        <button class="btn btn-primary" @click="$emit('exportInvoices')">Export</button>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import debounce from 'debounce';
import Sidebar from '@/modules/common/Sidebar';
import FilterDropdown from './FilterDropdown';
import format from 'date-fns/format';

export default {
  props: {
    options: { type: Array },
    indentFilters: { type: Array },
    vehicleTypes: { type: Array },
    invoiceFilters: { type: Array },
    depotList: { type: Array },
    seletedOption: { type: Object },
    seletedIndentType: { type: Object },
    selectedInvoiceType: { type: Object },
    seletedVehicleType: { type: Object },
    defaultDepot: {},
    canCreateInvoice: { type: Boolean },
    showPayment: { type: Boolean },
  },
  components: {
    Sidebar, FilterDropdown,
  },
  data() {
    return {
      queryPayment: null,
      queryInvoice: null,
      isOpen: false,
      showCreateInvoice: true,
      dateFormat: 'D MMM',
      startDate: '',
      endDate: '',
      selectedDepot: null,
    };
  },
  created() {
    this.selectedDepot = this.defaultDepot;
  },
  methods: {
    formatDates(startDate, endDate) {
      let formattedDates = '';
      if (startDate) {
        formattedDates = format(startDate, this.dateFormat);
      }
      if (endDate) {
        formattedDates += ` - ${format(endDate, this.dateFormat)}`;
      }
      return formattedDates;
    },
    onCloseMenu() {
      this.isOpen = false;
    },
    openMenu: function open() {
      this.isOpen = true;
    },
    clearDate() {
      this.startDate = '';
      this.endDate = '';
      this.$emit('changeDate', { start: '', end: '' });
    },
    filterByDate() {
      this.$emit('changeDate', { start: this.startDate, end: this.endDate });
    },
    onChangeDepotFilter() {
      this.$emit('depotFilterChange', this.selectedDepot);
    },
    onChangeOption(data) {
      if (data.id === 1) {
        this.showCreateInvoice = false;
      } else {
        this.showCreateInvoice = true;
      }
      this.$emit('change', data);
    },
    onChangeIndentFilter(data) {
      this.$emit('indentFilterChange', data);
    },
    onChangeInvoiceFilter(data) {
      this.$emit('invoiceFilterChange', data);
    },
    onChangeVehicleType(data) {
      this.$emit('vehicleFilterChange', data);
    },
    searchPayment: debounce(function debounceSearch() {
      const searchQuery = this.queryPayment;
      this.$emit('searchPayment', searchQuery);
    }, 500),
    searchInvoice: debounce(function debounceSearch() {
      const searchQuery = this.queryInvoice;
      this.$emit('searchInvoice', searchQuery);
    }, 500),
  },
};
</script>
<style lang="scss" scoped>
@import "~@common/styles-transporter/settings";

.primary-filter {
    border: 1px solid #DEE5E6;
    background-color: #fff;
    height: 50px;
    font-family:$fontSemibold;
    .dropdown-menu {
      // top: 32px !important;
    }
    .filter-grid {
        padding-left: 0;
        padding-right: 0;
        // border-left: 1px solid #CBD4D8;
        ul {
            @extend %list-unstyled;
            li {
                display: inline-block;
            }
            .app-side-menu {
                // background-color: #F2F1F1;
                padding: 13px 0;
                width: 69px;
                text-align: center;
                position: relative;
                top: 1px;
                background: #F2F1F1;
                cursor: pointer;
            }
            .category {
                width: 210px;
                padding: 4px 20px;
                color: #007FEA;
                padding-left: 10px;
                border-right: 1px solid #E9F1F5;
                // border-left: 1px solid #CBD4D8;
                font-size: 1.4rem;
                text-transform: uppercase;
                margin-left: -3px;
                position: relative;
                top: -1px;
                height: 50px;
                .dropdown {
                    padding: 12px 10px;
                }
            }
            .search {
                padding: 0 20px;
                width: 50%;
                svg {
                    position: relative;
                    top: 0px;
                }
                input {
                    outline: none;
                    border: 1px solid transparent;
                    padding: 0 5px;
                    width: 90%;
                    font-size: 1.4rem;
                }
            }
        }
        &.filter-button {
            ul {
                @extend %list-unstyled;
                float: right;
                padding: 4px 10px;
                li {
                    margin: 0 0 0 5px;
                    &:last-child {
                        margin: 0 0 0 10px;
                    }
                    .btn-primary {
                        @extend %header-primary-btn;
                        @extend %bold;
                        color: #fff;
                        text-transform: uppercase;
                    }
                    .btn-secondary {
                        @extend %header-secondary-btn;
                        @extend %bold;
                        color: #008AFF;
                        text-transform: uppercase;
                    }
                    .btn-primary[disabled] {
                      opacity: 0.5;
                      cursor: not-allowed;
                    }
                }
            }
        }
    }
}
.btn-primary[disabled] {
  opacity: 0.5;
}
.datepickerrange{
.datepicker-trigger{
  display: inline-block;
input{
  width: 100%;
  font-family:$fontSemibold;
  font-size: 1.2rem;
  color: #3a687d;
  text-transform: uppercase;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  border-left: 1px solid #ddd;
  padding: 0px 20px 0 0px;
  height: 44px;
  position: relative;
  margin-top: -10px;
  text-align: center;
  outline: none;
  margin-right: 40px;
}
}
&-cancel{
  display: inline-block;
  position: relative;
  right: 25px;
  cursor: pointer;
}
}
.borderstyletemp{
  .btn-group{
  border-right: 1px solid #DEE5E6;
  padding-right: 10px !important;
}
}
.paysection{
.dropdown-section{
  .depotfilter{
    width: 200px !important;
    //border-left:1px solid #DEE5E6;
  }
}
}
</style>
